import { Footer } from "@/components/Layout/BaseLayouts/Footer/Footer.tsx";
import { FCC } from "@/types";

import { ContentContainer } from "./ContentContainer";
import { Header, HeroTheme } from "./Header";

interface Props {
  headline?: string;
  /** Illustration set of the hero banner. Defaults to the SIM cards. */
  heroTheme?: HeroTheme;
}

/**
 * Every direct child passed to DefaultPageLayout must declare its own col-span
 * - there's no full-width fallback.
 */
export const DefaultPageLayout: FCC<Props> = ({
  children,
  headline,
  heroTheme,
}) => {
  return (
    <div className="flex min-h-screen flex-col bg-background-secondary">
      <Header variant="welcome" headline={headline} heroTheme={heroTheme} />
      <ContentContainer className="flex-grow">{children}</ContentContainer>
      <Footer />
    </div>
  );
};
